import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import App from './app/App';

const rootNode = document.getElementById('root');

if (!rootNode) {
  throw new Error('Root element not found');
}

createRoot(rootNode).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
